export interface BreadcrumbInput {
  template: string;
  label: string;
}

export interface Breadcrumb {
  href: string;
  label: string;
}

function substitute(template: string, params: Record<string, string>): string {
  return template.replace(/\[([^\]]+)\]/g, (_, key) => {
    const v = params[key];
    if (v === undefined) throw new Error(`Missing parameter "${key}" for "${template}"`);
    return v;
  });
}

export function computeBreadcrumbs(
  inputs: readonly BreadcrumbInput[],
  params: Record<string, string>,
): Breadcrumb[] {
  return inputs.map((i) => ({ href: substitute(i.template, params), label: i.label }));
}
